/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ActorId } from "../../commons/types/ActorId";
export const MappingRuleConfig = core.serialization.object({
    name: core.serialization.string(),
    type: core.serialization.string(),
    config: core.serialization.any().optional(),
    acceptedAt: core.serialization.date().optional(),
    acceptedBy: ActorId.optional(),
    metadata: core.serialization.any().optional(),
});
